const application = {
	pageNotFound: "Side ikke funnet",
	backToFrontpage: "Tilbake til forsiden"
};

export default application;
export { application };
